/**
 * Map of local_politicians country codes to their display names.
 * To add a new country, simply add an entry here — types, arrays, and UI
 * components all derive from this single source of truth.
 */
export const LOCAL_POLITICIANS_COUNTRIES: Record<string, string> = {
  tur: 'Turkey',
  che: 'Switzerland',
  gbr: 'United Kingdom',
  deu: 'Germany',
  esp: 'Spain',
  cze: 'Czech Republic',
  // ita: 'Italy',
  usa: 'United States',
  grc: 'Greece',
  ury: 'Uruguay',
  fra: 'France',
  vat: 'Holy See',
  irn: 'Iran',
  ukr: 'Ukraine',
  guy: 'Guyana',
  glp: 'Guadeloupe',
  can: 'Canada',
  aut: 'Austria',
  phl: 'Philippines',
  chl: 'Chile',
  svn: 'Slovenia',
  ind: 'India',
  cck: 'Cocos (Keeling) Islands',
  blr: 'Belarus',
  zwe: 'Zimbabwe',
  prt: 'Portugal',
  cyp: 'Cyprus',
  lie: 'Liechtenstein',
  ecu: 'Ecuador',
  bel: 'Belgium',
  mlt: 'Malta',
  npl: 'Nepal',
  kor: 'South Korea',
  uga: 'Uganda',
  rou: 'Romania',
  hrv: 'Croatia',
  nzl: 'New Zealand',
  khm: 'Cambodia',
};

export type HexaBaseInterestArea =
  | 'adverse_media'
  | 'pep'
  | 'local_politicians'
  | 'legal_enforcement'
  | 'sanctions'
  | 'whitelists'
  | 'public_functions';

export type LocalPoliticiansCountryCode = keyof typeof LOCAL_POLITICIANS_COUNTRIES;

export type HexaInterestArea =
  | HexaBaseInterestArea
  | `local_politicians_${string}`;

export type ExecutionDay =
  | 'MON'
  | 'TUE'
  | 'WED'
  | 'THU'
  | 'FRI'
  | 'SAT'
  | 'SUN';

export type DopType = 'DEFAULT_JSON' | 'BNL' | 'VITTORIA' | 'BANCA_STATO';

export const DOP_TYPES: Array<DopType> = [
  'DEFAULT_JSON',
  'BNL',
  'VITTORIA',
  'BANCA_STATO',
];

export const EXECUTION_DAYS: Array<ExecutionDay> = [
  'MON',
  'TUE',
  'WED',
  'THU',
  'FRI',
  'SAT',
  'SUN',
];

type JsonValue = string | number | boolean | null | JsonObject;

export type JsonObject = { [key: string]: JsonValue };
